//#region src/loyalty_signup_mode.ts
let LoyaltySignupMode = /* @__PURE__ */ function(LoyaltySignupMode) {
	LoyaltySignupMode["Simple"] = "simple";
	LoyaltySignupMode["InstantEnroll"] = "instant-enroll";
	return LoyaltySignupMode;
}({});
//#endregion
export { LoyaltySignupMode };

//# sourceMappingURL=loyalty_signup_mode.js.map